import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationUA from './locales/ua/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  ua: {
    translation: translationUA,
  },
};

const supportedLanguages = ['ua', 'en'];
const urlLanguage = new URLSearchParams(window.location.search).get('lang');

if (urlLanguage && supportedLanguages.includes(urlLanguage)) {
  localStorage.setItem('uucLanguage', urlLanguage);
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('uucLanguage') || 'ua',
    fallbackLng: 'ua',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;